import { styled } from '@mui/material';
import { Box, Button, Form, Icon, PasswordInput, Stack, Text, TextInput } from 'shell/components';
import { PASSWORD_REQUIREMENTS } from 'utils/password';

const SignupProfilePage = ({
    device,
    loading,
    form,
    errors,
    passwordRequirements,
    handleChange,
    handleBack,
    handleCreateAccount,
}) => (
    <Card device={device}>
        <Stack alignItems={'center'} spacing={1}>
            <Text component={'h1'} variant={'h6'} weight={'medium'}>
                Create an account
            </Text>
            <Text variant={'p1'} align={'center'}>
                Next, let’s finish setting up your profile and password to protect your account.
            </Text>
        </Stack>
        <Form onSubmit={handleCreateAccount}>
            <Stack spacing={4} sx={{ mt: 7 }}>
                <Stack direction={device === 'mobile' ? 'column' : 'row'} spacing={4}>
                    <TextInput
                        autoComplete={'given-name'}
                        error={Boolean(errors.firstName)}
                        helperText={errors.firstName}
                        label={'First Name'}
                        placeholder={'Enter first name'}
                        value={form.firstName}
                        onChange={(event) => handleChange('firstName', event.target.value)}
                        required
                    />
                    <TextInput
                        autoComplete={'family-name'}
                        error={Boolean(errors.lastName)}
                        helperText={errors.lastName}
                        label={'Last name'}
                        placeholder={'Enter last name'}
                        value={form.lastName}
                        onChange={(event) => handleChange('lastName', event.target.value)}
                        required
                    />
                </Stack>
                <Stack spacing={2}>
                    <PasswordInput
                        autoComplete={'new-password'}
                        error={Boolean(errors.password)}
                        helperText={errors.password}
                        label={'Enter Password'}
                        placeholder={'Enter password'}
                        value={form.password}
                        onChange={(event) => handleChange('password', event.target.value)}
                        required
                    />
                    <Stack>
                        <Text variant={'p3'} color={'light'}>
                            The password must have:
                        </Text>
                        {PASSWORD_REQUIREMENTS.map(({ key, label }) => (
                            <Text key={key} variant={'p3'} color={passwordRequirements[key] ? 'light' : 'error'}>
                                • {label}
                            </Text>
                        ))}
                    </Stack>
                </Stack>
                <PasswordInput
                    autoComplete={'new-password'}
                    error={Boolean(errors.confirmPassword)}
                    helperText={errors.confirmPassword}
                    label={'Confirm Password'}
                    placeholder={'Enter password'}
                    value={form.confirmPassword}
                    onChange={(event) => handleChange('confirmPassword', event.target.value)}
                    required
                />
            </Stack>
            <Stack direction={'row'} justifyContent={'space-between'} sx={{ mt: 7 }}>
                <Button
                    variant={'tertiary'}
                    color={'neutral'}
                    startIcon={<Icon kind={'arrowLeft'} />}
                    onClick={handleBack}
                >
                    Back
                </Button>
                <Button loading={loading} type={'submit'}>
                    Next
                </Button>
            </Stack>
        </Form>
    </Card>
);

const Card = styled(Box)(({ theme, device }) => ({
    marginTop: theme.spacing(12),
    padding: device === 'mobile' ? 0 : theme.spacing(7),
    width: device === 'mobile' ? '100%' : 448,
    background: device === 'mobile' ? 'transparent' : theme.palette.ensightful.shades[0],
    boxShadow: device === 'mobile' ? 'none' : theme.palette.ensightful.shadows[1],
    borderRadius: '20px',
}));

export default SignupProfilePage;
